import Vue from 'vue';

export function getComponentName(component: Vue): string {
  // Try to get name from component options first
  const name = component?.$options?.name;
  if (name) return name;

  // Try to get name from file path
  const fileName = component?.$options?.__file;
  // Return 'Anonymous' for Unknown file paths
  if (fileName === 'Unknown') return 'Anonymous';

  if (fileName) {
    // Extract base name without extension
    const match = fileName.match(/([^/\\]+)\.vue$/);
    return match ? match[1] : fileName;
  }

  return 'Anonymous';
}

export function getFilePath(component: Vue): string {
  // Try to get filename as fallback
  const fileName = component?.$options?.__file;
  if (fileName) {
    // Extract base name without extension
    const match = fileName.match(/([^/\\]+)\.vue$/);
    return match ? match[1] : fileName;
  }

  return 'Unknown';
}
